/**
 * Static channel configuration for the "Impact in beeld" hub.
 * Source: handoff + docs/features/impact-in-beeld-hub.md.
 *
 * @typedef {object} ImpactChannel
 * @property {string} id - Stable identifier, stored as ChannelId on ImpactChannels docs
 * @property {string} title - Channel name shown to the user
 * @property {string} description - What the channel does
 * @property {'print'|'live'|'document'} outputType - Kind of output the channel produces
 * @property {Array<string>} requirements - Keys of REQUIREMENT_LABELS this channel needs
 */

/** Requirement keys → chip labels shown on channel cards. */
export const REQUIREMENT_LABELS = {
    meting: 'Meting',
    producten: 'Producten',
    kassakoppeling: 'Kassakoppeling',
    webshopkoppeling: 'Webshopkoppeling',
}

/** @type {Array<ImpactChannel>} */
const impactChannels = [
    {
        id: 'tafelkaart',
        title: 'Tafelkaart',
        description: 'Toon je impact in één overzicht op tafels of aan de balie.',
        outputType: 'print',
        requirements: ['meting'],
    },
    {
        id: 'hangtags',
        title: 'Hangtags',
        description: 'Laat de impact van een product er direct naast zien — als vast onderdeel van je product.',
        outputType: 'print',
        requirements: ['meting', 'producten'],
    },
    {
        id: 'kassascherm',
        title: 'Live scherm bij kassa',
        description: 'Toon je impact in real time; je impact telt op bij elke afrekening. Kan op elk scherm, tablet of narrowcasting-display.',
        outputType: 'live',
        requirements: ['meting', 'kassakoppeling'],
    },
    {
        id: 'kassabon',
        title: 'Kassabon',
        description: 'Toon je klanten bij iedere afrekening de impact waar ze aan bijdragen.',
        outputType: 'document',
        requirements: ['meting', 'kassakoppeling'],
    },
    {
        id: 'offerte-factuur',
        title: 'Offerte/factuur',
        description: 'Laat klanten zien welke maatschappelijke waarde ze met hun opdracht creëren.',
        outputType: 'document',
        requirements: ['meting', 'producten'],
    },
    {
        id: 'website-widget',
        title: 'Website-widget',
        description: 'Een real-time overzicht van je impact, ingebed op je eigen website.',
        outputType: 'live',
        requirements: ['meting'],
    },
    {
        id: 'webshop-widget',
        title: 'Webshop-widget',
        description: 'Toon de impact per product, direct in je webshop.',
        outputType: 'live',
        requirements: ['meting', 'producten', 'webshopkoppeling'],
    },
]

export default impactChannels
